import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import TopMenuBarProps from './TopMenuBarProps';
import styles from './TopMenuBarScreen.module.scss';
import i18n from 'i18next';
import { Switch } from 'devextreme-react/switch';
import InspectorContextProvider, {
    useInspectorContext,
    InspectorContext,
} from 'fulogics-ui-web/dist/layout/inspector/context/InspectorContext';
import { isFunction } from 'fulogics-ui-core/dist/devExtremeInterop/type';
import Button from 'devextreme-react/button';
import { useToggle } from 'fulogics-ui-core/dist/layout/hooks/useToggle';
import InspectorScreen from 'fulogics-ui-web/dist/layout/inspector/screen/InspectorScreen';
import { useTranslation } from 'react-i18next';
import { PATH_ORDER_EDIT } from '../../../constants/routerPaths';

//TODO
// translacja

export default function TopMenuBarScreen(props: TopMenuBarProps) {
    const [expand, expandMenu] = React.useState(false);
    const { disabled, setDisabled } = useInspectorContext();
    const [inspectorFormVisible, setInspectorFormVisible] = useToggle(false);
    const [wmsExternalId, setWmExternalId] = useState<string>();
    const [tmsExternalId, setTmsExternalId] = useState<string>('');

    const { t } = useTranslation('TopMenuBarScreen');

    const { user, logoutUser, value, match, userId, reportId } = props;
    let translateValue = value;

    useEffect(() => {
        if (match.params?.orderId && match.path === PATH_ORDER_EDIT) {
            props
                .cosOrderById?.({
                    id: match.params?.orderId,
                    keys: ['tmsExternalId', 'wmsExternalId'],
                })
                ?.then((r: any) => {
                    setWmExternalId(r.wmsExternalId);
                    setTmsExternalId(r.tmsExternalId);
                });
        }
    }, [match]);

    const title = t(`routes.${match.path.replace(/\//g, '').replace(':', '_')}`, {
        value: translateValue,
        userId: userId,
        reportId: reportId,
        wmsExternalId: wmsExternalId,
        tmsExternalId: tmsExternalId ? `, ${tmsExternalId}` : '',
    });

    const editModeSwitchChangedValue = (e: { value?: boolean }) => {
        // @ts-ignore
        setDisabled?.(!e.value);
    };

    return (
        <OutsideClickHandler
            onOutsideClick={() => {
                expandMenu(false);
            }}
        >
            <div className={styles.container}>
                <div className={styles.title}>{title}</div>
                <div className={styles.editMode}>
                    <Switch value={!disabled} onValueChanged={editModeSwitchChangedValue} />
                    <Button visible={!disabled} icon="edit" onClick={setInspectorFormVisible} />
                </div>
                {user && (
                    <div className={styles.menu} onClick={() => expandMenu(!expand)}>
                        <div className={styles.section}>
                            <p className={styles.shipper}>{t('top.title')}</p>
                            <p className={styles.value}>{`${user.name} ${user.surname}`}</p>
                            <p className={styles.arrow}>
                                <FontAwesomeIcon icon={'sort-down'} />
                            </p>
                        </div>
                        <ul
                            className={classNames(styles.menuList, {
                                [styles.menuListActive]: expand,
                            })}
                        >
                            <li className={styles.menuItem}>
                                <div className={styles.menuLink} onClick={logoutUser}>
                                    {t('top.logout')}
                                </div>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
            <InspectorScreen visible={inspectorFormVisible} onClose={setInspectorFormVisible} />
        </OutsideClickHandler>
    );
}
